import React from 'react'
import CollegeStBanner from './Components/CollegeStBanner'
import CollegeStBody from './Components/CollegeStBody'
import IndexFooter from '../Index/Components/IndexFooter'
// import TopBar from '../ProjectComponents/TopBar'
import SEOHelmet from '../ProjectComponents/SEOHelmet'

function CollegeStudentVideos() {
  const page = 'college-student-videos'
  return (
    <>
        <SEOHelmet page={page} />
        {/* topbar */}

        <div className='bg-findColleges main'>
          {/* <TopBar/> */}
          <CollegeStBanner/>
        </div>
        <CollegeStBody/>
        <IndexFooter/>
    </>
  )
}

export default CollegeStudentVideos